class Facets extends HTMLElement {
  constructor() {
    super();

    this.form = document.querySelector('.js-facets-form');

    if(this.form) {
      this.productGrid = document.querySelector('.js-collection-results') || null;

      this.form.addEventListener('input', this.debounce((event) => {
        this.handleFormChange(event);
      }, 300));

      document.querySelectorAll('.js-remove-filter').forEach(element => {
        element.addEventListener('click', (event) => this.handleRemoveFilter(event));
      });

      document.querySelectorAll('.js-facets-form input[type="checkbox"]').forEach(element => {
        element.addEventListener('change', (event) => this.handleInputChange(event));
      });

      document.querySelectorAll('.js-change-sort-by-value').forEach(element => {
        element.addEventListener('click', (event) => this.handleSortBy(event));
      });

      document.querySelectorAll('.js-toggle-filter').forEach(element => {
        element.addEventListener('click', (event) => this.handleToggleFilter(event));
      });

      document.querySelectorAll('.js-clear-filter').forEach(element => {
        element.addEventListener('click', (event) => this.handleClearFacets(event));
      });
    }
  }

  handleFormChange() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData);
    
    const activeSortElement = document.querySelector('.js-change-sort-by-value.active');
    if (activeSortElement) {
      const sortValue = activeSortElement.getAttribute('data-value');
      if (sortValue) {
        searchParams.set('sort_by', sortValue);
      }
    }

    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) {
      searchParams.set('view', currentView);
    }
    
    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.renderPage(searchParams.toString());

    this.toggleLoadingClass('add');

    this.updateActiveFiltersCounter();
  }

  handleSortBy(event) {
    event.preventDefault();
    const sortValue = event.currentTarget.getAttribute('data-value');
    if (!sortValue) return;
    
    let searchParams;

    if(this.form) {
      const formData = new FormData(this.form);
      searchParams = new URLSearchParams(formData);
    } else {
      searchParams = new URLSearchParams();
    }
    searchParams.set('sort_by', sortValue);

    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) {
      searchParams.set('view', currentView);
    }
    
    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.renderPage(searchParams.toString());
    
    document.querySelectorAll('.js-change-sort-by-value').forEach(el => el.classList.remove('active'));
    event.currentTarget.classList.add('active');
    
    const currentSortDisplay = document.querySelector('.js-current-sort-by');
    if (currentSortDisplay) {
      currentSortDisplay.textContent = event.currentTarget.textContent;
    }

    this.classList.add('loading');

    this.updateActiveFiltersCounter();
  }

  handleToggleFilter(event) {
    event.preventDefault();
    const toggleButton = event.currentTarget;

    if (window.innerWidth < 992) {
      const toggleEls = Array.from(document.querySelectorAll('.js-toggle-filter')).map(el => el.parentElement);
      const containerEl = document.querySelector('.js-facets-container');

      const isOpen = toggleEls[0].classList.contains('show');

      if (isOpen) {
        toggleEls.forEach(toggleEl => toggleEl.classList.add('closing'));
        toggleEls.forEach(toggleEl => toggleEl.classList.remove('show-2'));
        containerEl.classList.add('closing');
        document.body.style.overflow = 'visible';

        setTimeout(() => {
          toggleEls.forEach(toggleEl => toggleEl.classList.remove('closing', 'show', 'display'));
          containerEl.classList.remove('show', 'closing', 'display');
        }, 300);
      } else {
        toggleEls.forEach(toggleEl => toggleEl.classList.add('display'));
        containerEl.classList.add('display');
        document.body.style.overflow = 'hidden';

        setTimeout(() => {
          toggleEls.forEach(toggleEl => toggleEl.classList.add('show'));
          containerEl.classList.add('show');
        }, 50);

        setTimeout(() => {
          toggleEls.forEach(toggleEl => toggleEl.classList.add('show-2'));
        }, 400);
      }

      toggleEls.forEach(toggleEl => toggleEl.classList.toggle('active'));

      return;
    }

    document.querySelectorAll('.js-facets-container').forEach(element => {
      if (element.classList.contains("active")) {
        const currentHeight = element.scrollHeight;
        element.style.height = currentHeight + 'px';

        void element.offsetHeight;

        element.style.transition = 'height 0.3s ease';
        element.style.height = '0px';
        element.classList.remove("active");

        toggleButton.classList.remove("active");
      } else {
        element.classList.add("active");

        const targetHeight = element.scrollHeight;
        element.style.height = '0px';

        void element.offsetHeight;

        element.style.transition = 'height 0.3s ease';
        element.style.height = targetHeight + 'px';

        toggleButton.classList.add("active");
      }
    });
  }

  toggleLoadingClass(type) {
    if(type == 'add') {
      this.classList.add('loading');
    } else {
      this.classList.remove('loading');
    }
  }

  renderPage(searchParams) {
    const currentView = new URL(window.location.href).searchParams.get('view');
    const viewParam = currentView ? `&view=${currentView}` : '';
    const url = `${window.location.pathname}?${searchParams}${viewParam}`;

    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const productGridContent = doc.querySelector('.js-collection-results');
        if (productGridContent && this.productGrid) {
          this.productGrid.innerHTML = productGridContent.innerHTML;

          const offset = 120;
          const elementPosition = this.productGrid.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }

        const newLoadMore = doc.querySelector(".js-load-more-results");
        const currentLoadMore = document.querySelector(".js-load-more-results");

        if(newLoadMore && currentLoadMore) {
          if (!newLoadMore.parentElement.classList.contains("d-none")) {
            currentLoadMore.parentElement.classList.remove('d-none');
          } else {
            currentLoadMore.parentElement.classList.add('d-none');
          } 

          const newHref = newLoadMore.getAttribute("href");
          if (newHref) {
            currentLoadMore.setAttribute("href", newHref);
          }

          const newOriginalText = currentLoadMore.getAttribute("data-original-text") || originalText;
          const span = currentLoadMore.querySelector("span") || currentLoadMore;
          span.textContent = newOriginalText;
        }

        if (window.innerWidth > 991 && typeof initParallax === 'function') {
          initParallax();
        }

        if(typeof initializeObservers === 'function') {
          initializeObservers();
        }

        document.querySelectorAll('.js-media-counter').forEach((el, index) => {
          el.innerHTML = index + 1;
        });

        this.toggleLoadingClass('remove');
      })
      .catch(error => {
        console.error('Error fetching filtered results:', error);
        this.toggleLoadingClass('remove');
      });
  }

  addActiveFilter(filterParam, filterValue, filterLabel) {
    const activeFiltersContainers = document.querySelectorAll('.js-active-filters');
    if (!activeFiltersContainers.length) return;

    activeFiltersContainers.forEach(activeFiltersContainer => {
      let existingFilter = activeFiltersContainer.querySelector(`a[data-filter="${filterParam}"][data-value="${filterValue}"]`);
      if (existingFilter) return;

      const li = document.createElement('li');
      const anchor = document.createElement('a');
      anchor.href = "#";
      anchor.classList.add('js-remove-filter');
      anchor.setAttribute('data-filter', filterParam);
      anchor.setAttribute('data-value', filterValue);
      anchor.innerHTML = `<span>✕</span> ${filterLabel}`;

      li.appendChild(anchor);
      activeFiltersContainer.appendChild(li);

      anchor.addEventListener('click', (event) => this.handleRemoveFilter(event));
    });
  }

  handleRemoveFilter(event) {
    event.preventDefault();
    
    const filterParam = event.currentTarget.getAttribute('data-filter');
    const filterValue = event.currentTarget.getAttribute('data-value');
    
    if (!filterParam || !filterValue) return;
    
    const checkbox = document.querySelector(`input[name="${filterParam}"][value="${filterValue}"]`);
    if (checkbox) {
      checkbox.checked = false;
    }
    
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData);
    
    searchParams.delete(filterParam);

    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) {
      searchParams.set('view', currentView);
    }
    
    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.renderPage(searchParams.toString());
    
    document.querySelectorAll(`.js-remove-filter[data-filter="${filterParam}"][data-value="${filterValue}"]`).forEach(filter => filter.parentElement?.remove());

    this.toggleLoadingClass('add');

    this.updateActiveFiltersCounter();
  }

  handleClearFacets(event) {
    event.preventDefault();
    
    document.querySelectorAll('.js-facets-form input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false;
    });
    
    document.querySelectorAll('.js-remove-filter').forEach(filter => {
      filter.parentElement?.remove();
    });
    
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData);
    searchParams.delete('q');

    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.renderPage(searchParams.toString());
    
    this.toggleLoadingClass('add');

    this.updateActiveFiltersCounter();
  }

  handleInputChange(event) {
    const filterParam = event.target.name;
    const filterValue = event.target.value;
    const filterLabel = event.target.closest('label')?.textContent.trim() || filterValue;
    
    if (event.target.checked) {
      this.addActiveFilter(filterParam, filterValue, filterLabel);
    } else {
      document.querySelectorAll(`.js-remove-filter[data-filter="${filterParam}"][data-value="${filterValue}"]`).forEach(activeFilter => activeFilter.parentElement?.remove());
    }
  }

  updateActiveFiltersCounter() {
    const activeFilters = document.querySelectorAll('.js-remove-filter').length;
    document.querySelectorAll('.js-clear-filter, .js-active-filters, .js-filter-counter, .js-facets-container').forEach(element => {
      element.setAttribute('data-counter', activeFilters);
    });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('collection-facets', Facets);